import Page from "../components/Page";
import checkMark from "../assets/images/check-mark.gif"
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { setAttendance } from "../api/admin/AdminDashboardAPI";
import { checkSession, login } from "../api/login/UserLogin";



const AttendancePage = () => {

    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const location = useLocation();

    let eventHash = searchParams.get("event");
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(true);
    const [recorded, setRecorded] = useState(false);
    const [roles, setRoles] = useState([]);
    const intervalId = useRef(null);


    const [gifSrc, setGifSrc] = useState(Date.now());
    useEffect(() => {
        setGifSrc(`${checkMark}?${Date.now()}`); // Force reload of gif by adding a query parameter
    }, []);


    useEffect(() => {
        const initializePage = async () => {
            setLoading(true);

            try {
                const allRoles = await checkSession(location.pathname + "?event=" + eventHash, navigate);
                setRoles(allRoles);

                const r = await setAttendance(eventHash);
                console.log(r.status);

                switch(r.status) {
                    case 200:
                        setSuccess(true);
                        setRecorded(true);
                        break;
                    case 208:
                        setSuccess(false);
                        setRecorded(true);
                        break;
                     default:
                       // Handle other statuses or errors if needed
                       console.error("Unexpected status from setAttendance:", r.status);
                       setSuccess(false);
                       setRecorded(false);
                       break;
                }

            } catch (error) {
                console.error("Error during page initialization:", error);
                setSuccess(false);
                setRecorded(false);
            } finally {
                // Set loading to false only after both operations complete
                setLoading(false);
                console.log("not loading");
            }
        };

        initializePage();

        intervalId.current = setInterval(() => {
            checkSession(location.pathname + "?event=" + eventHash, navigate);
        }, 15 * 60 * 1000); // every 15 min, check session

        // Cleanup interval on unmount
        return () => clearInterval(intervalId.current);

    }, [eventHash, location.pathname, navigate]);


    const correctRolesForMemberDashboard = ["MEMBER"].some(r => roles.includes(r));
    const correctRolesForAdminDashboard = ["ADMIN"].some(r => roles.includes(r));
    const [linkText, setLinkText] = useState("");
    useEffect(() => {
        if (correctRolesForAdminDashboard) {
            setLinkText("Link to Admin Dashboard");
        } else if (correctRolesForMemberDashboard) {
            setLinkText("Link to Member Dashboard");
        } else {
            setLinkText("Link to Registration Page");
        }
    }, [correctRolesForAdminDashboard, correctRolesForMemberDashboard]);

    if (loading) {
        return (
            <Page>
                <div>Loading....</div>
            </Page>
        );
    } else if (success === false) {
        if (recorded === false) {
            navigate('/error', { replace: true });
        }
        return (
            <Page>
                <div style={{ display: 'grid', placeItems: 'center' }}>
                    <h1>Attendance already recorded!</h1>
                    <img src={gifSrc} alt="GIF of check mark, attendance has been recorded successfully" style={{width:200, height:150}}/>
                    <p>You've already been recorded for attendance</p>
                    <span
                        onClick={() => {
                            if (correctRolesForAdminDashboard) {
                                navigate("/admin/members");
                            }
                            else if (correctRolesForMemberDashboard) {
                                navigate("/member/dashboard");   
                            } else {
                                navigate("/register");
                            }
                        }}
                        className="text-link"
                    >
                        {linkText}
                    </span>
                </div>
                
            </Page>
        );
    } else {
        return (
            <Page>
                <div style={{ display: 'grid', placeItems: 'center' }}>
                    <h1>Attendance Recorded!</h1>
                    <img src={gifSrc} alt="GIF of check mark, attendance has been recorded successfully" style={{width:200, height:150}}/>
                    <p>Your attendance for this event has been successfully recorded.</p>
                    <span
                        onClick={() => {
                            if (correctRolesForAdminDashboard) {
                                navigate("/admin/members");
                            } else if (correctRolesForMemberDashboard) {
                                navigate("/member/dashboard");   
                            } else {
                                navigate("/register");
                            }
                        }}
                        className="text-link"
                    >
                        {linkText}
                    </span>
                </div>
                
            </Page>
        );
    }
};

export default AttendancePage;